
import { Component, Prop, Vue } from "vue-property-decorator";
import { AreaFilterItem } from "@/types/area-tree-select/AreaFilter";
import AreaTreeSelect from "@/components/form/AreaTreeSelect.vue";
import { AreaNode } from "@/types/sv-data/groups/AreaNode";
import { truncateString } from "@/filters";

@Component({
	filters: { truncateString },
	components: {
		"area-tree-select": AreaTreeSelect
	}
})

export default class AdvancedAreaFilter extends Vue {
	@Prop({ type: Boolean, default: false })
	excludedFeatureEnabled: boolean;

	@Prop({ default: () => [] })
	public areaListState: AreaFilterItem[];

	public reset(): void {
		this.areaList = [];
		this.$emit("input", this.areaList);
	}

	private areaList: AreaFilterItem[] = [];

	private mounted(): void {
		if (this.areaListState.length > 0) {
			this.areaList = this.areaListState;
		}
	}

	private beforeDestroy(): void {
		this.areaList = [];
	}

	public areaSelected(selectedArea: AreaNode): void {
		if (!selectedArea) {
			this.areaList = [];
			this.$emit("input", this.areaList);
			return;
		}

		let groupIndex = this.areaList.findIndex((area: any) => area.id == selectedArea.id);
		if (groupIndex < 0 || groupIndex === null || groupIndex === undefined) {
			this.areaList.push({
				id: selectedArea.id,
				label: selectedArea.label,
				inherited: !!selectedArea.children,
				excluded: false
			});
		} else {
			this.areaList.splice(groupIndex, 1);
		}

		this.$emit("input", this.areaList);
	}
}
